import { FC } from 'react'

import { Txt, NotExistsUserIllustration } from 'src/components/atoms'

type Props = {
  className?: string
}

export const NotExistsUserMessage: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <div className="tw-bg-surface-primary tw-pt-s0 tw-pb-s2">
        <div className="tw-centering tw-flex-col">
          <NotExistsUserIllustration className="tw-w-[12.14rem]" />
          <Txt className="tw-font-bold tw-text-roovPrimary-default tw-mt-s0">
            ユーザーが存在しません
          </Txt>
        </div>
      </div>
    </div>
  )
}
